import axios from "axios";

// Backend CORS ayarları yapılana kadar direkt URL kullanıyoruz
const API_BASE_URL = "https://api.yikafoni.com/api/v3";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// İstek öncesi token kontrolü
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Giden isteğin yapılandırmasını logla
    console.log("Axios Request Interceptor - Config:", config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Yanıt kontrolü (Basitleştirildi: Doğrudan response.data dönülüyor)
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token geçersiz veya süresi dolmuş
      localStorage.removeItem("token");
      window.location.href = "/auth/login";
    }
    return Promise.reject(error);
  }
);

export default api;
